import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import type { Language, Localized } from '../types/content';
interface LanguageContextValue {
  lang: Language;
  setLang: (lang: Language) => void;
  toggle: () => void;
  t: (value: Localized) => string;
}
interface LanguageProviderProps {
  children: React.ReactNode;
  defaultLanguage?: Language;
}
const LanguageContext = createContext<LanguageContextValue | null>(null);
export function LanguageProvider({
  children,
  defaultLanguage = 'en'
}: LanguageProviderProps) {
  const [lang, setLang] = useState<Language>(defaultLanguage);
  useEffect(() => {
    setLang(defaultLanguage);
  }, [defaultLanguage]);
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  const value = useMemo<LanguageContextValue>(() => ({
    lang,
    setLang,
    toggle: () => setLang(l => l === 'en' ? 'es' : 'en'),
    t: (v: Localized) => v[lang]
  }), [lang]);
  return <LanguageContext.Provider value={value} data-id="element-462" data-mp="2jnb3obgxb6m4">{children}</LanguageContext.Provider>;
}
export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}